import Chance from 'chance';

import { LuckyWheelPrizesQuery } from '@hooks/luckywheel/luckyWheel.gql.generated';
import { NormalizedPrize } from './LuckyWheelContainer';

export const WHEEL_COLORS = [
  '#FFFF00',
  '#3369e8',
  '#d50f25',
  '#eeb211',
  '#009925',
  '#f57b00',
  '#00d600',
  '#6c00d6',
  '#d600d6',
  '#7f7f7f',
  '#ff0000',
  '#6699FF',
  '#34A24F',
  '#F9AA1F',
  '#EC3F3F',
  '#FF33FF',
  '#669999',
  '#FF9000',
  '#FF3366',
  '#07ed07',
  '#FFCC66',
  '#fcc2c2',
];

// Shuffle an array with predicted order
export function shuffle(array: any[]) {
  const seed = 0;
  const chance = new Chance(seed);
  return chance.shuffle(array);
}

// Based on the list and the target, calculate the angles to rotate the wheel...
// from the based position to reach the target
export function calculateAnglesToWin(list: NormalizedPrize[], target: NormalizedPrize['name'] | undefined): number[] {
  if (!target) {
    return [];
  }

  const anglePerItem = 360 / list.length;
  const result = [];

  for (let i = 0; i < list.length; i++) {
    const item = list[i].name;
    const angle = i * anglePerItem;

    if (item === target) {
      result.push(angle);
    }
  }

  return result;
}

export function calculateDegreeToRotate(loops: number, winningDegrees: number[]) {
  const index = Math.floor(Math.random() * winningDegrees.length);

  return loops * 360 + winningDegrees[index];
}

// Normalize prizes to make it easier to visualize the wheel in case of having
// huge difference in quantity between prizes
export function normalizePrizes(prizes: LuckyWheelPrizesQuery['luckyWheelPrizes']): NormalizedPrize[] {
  const prizesByOriginalQuantity = [...prizes].sort((a, b) => b.originalQuantity - a.originalQuantity);

  let count = 0;

  const normalizedPrizes: NormalizedPrize[] = prizesByOriginalQuantity
    .map(prize => {
      let normalizedQuantity;

      if (count === 0) {
        normalizedQuantity = 11;
        count++;
      } else if (count === 1) {
        normalizedQuantity = 4;
        count++;
      } else if (count === 2) {
        normalizedQuantity = 2;
        count++;
      } else {
        normalizedQuantity = 1;
        count++;
      }

      return {
        id: prize.id,
        name: prize.name,
        quantity: normalizedQuantity,
      };
    })
    .reduce((acc, prize) => {
      const temp = new Array(prize.quantity).fill(prize);
      return acc.concat(temp);
    }, [] as NormalizedPrize[]);

  return normalizedPrizes;
}
